
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip-paper-calendar)","fill":"#838383"}},[_c('path',{attrs:{"d":"M0 23.56h24V7.475H0V23.56zM17.794 9.82h2.483v2.483h-2.483V9.822zm0 4.222h2.483v2.483h-2.483v-2.483zm0 4.22h2.483v2.484h-2.483v-2.483zm-4.69-8.441h2.482v2.482h-2.482V9.822zm0 4.22h2.482v2.484h-2.482v-2.483zm0 4.222h2.482v2.483h-2.482v-2.483zM8.414 9.82h2.482v2.482H8.413V9.822zm0 4.22h2.482v2.484H8.413v-2.483zm0 4.222h2.482v2.483H8.413v-2.483zM3.723 9.82h2.482v2.482H3.723V9.822zm0 4.22h2.482v2.484H3.723v-2.483zm2.482 4.222v2.483H3.723v-2.483h2.483zM24 1.847h-4.221v2.814h-1.407V1.847H5.628v2.814H4.221V1.847H0v4.221h24v-4.22zM5.628.44H4.221v1.407h1.407V.44zM19.779.44h-1.407v1.407h1.407V.44z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip-paper-calendar"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    